import { 
	InnerBlocks, 
	useBlockProps 
} from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save(props) {
	const { attributes } = props;
	const pauseOnHover = attributes.options.pauseOnHover ? "pause-on-hover" : "";

	return (
		<div { ...useBlockProps.save({ className:`wpopus-marquee` }) }>
			<div className="wpopus-marquee-wrapper">
				<div
					className={`wpopus-marquee-content ${attributes.options.direction} ${pauseOnHover}`}
					style={{
						"--wpopus-marquee-speed": `${attributes.options.speed || 10}s`,
					}}
				>
					<InnerBlocks.Content />
				</div>
			</div>
	  	</div>
	);
}
